import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import creditProgramListAction from './creditProgramList.action.json' with { type: 'json' }
import { creditProgramObject } from '../creditProgramObject'

export const creditProgramExpression = expression(creditProgramObject.shape)

const creditProgramListDefinition = defineAction({
  ...creditProgramListAction,

  input: z.object({
    filter: creditProgramExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      name: 'Nome',
      activeYear: 'Ano de vigência',
      status: 'Situação',
      type: 'Tipo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(creditProgramObject),
    count: z.number(),
  }),
})

export default creditProgramListDefinition

